import { useStripeCompanyAccountQuery } from '@alice-financial/alice-sdk'

/**
 * Hook to get the Stripe connected account ID for the current organization.
 * 
 * This centralizes the logic for fetching and extracting the Stripe connected account ID
 * from the organization's Alice Card Program company account.
 * 
 * @returns The Stripe connected account ID (e.g., "acct_xxx") or null/undefined if not available
 */
export const useStripeConnectedAccountId = () => {
  const { data: stripeAccountData, ...queryState } = useStripeCompanyAccountQuery()
  
  const stripeAccount =
    stripeAccountData?.organization?.aliceCardProgram?.companyAccount?.stripeConnectedAccountId

  return {
    stripeAccount,
    ...queryState,
  }
}

